@import '../../../global/global.pcss';

:host {
  overflow: hidden;
}
